import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NewUiOrgSwitchComponent } from "./new-ui-org-switch.component";

@Component({
  selector: "app-org-switch",
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrgSwitchComponent extends NewUiOrgSwitchComponent {}
